export default () => {
  const a = new Uint32Array(5); // we want 4 32bit values
  const v = Array.from(window.crypto.getRandomValues(a))
    .map((i) => i.toString(16))
    .join('-');
  console.log(v);
  return v;
};
